import * as yup from 'yup';

export const getContactSchema = (fields) => {
  const shape = {};

  fields.forEach((field) => {
    let validator = yup.string();
    const message = field.errorMessage || `Поле "${field.label}" обов’язкове`;

    if (field.isRequired) {
      validator = validator.required(message);
    }

    if (field.name === 'phone') {
      validator = yup
        .string()
        .required(field.errorMessage || 'Введіть ваш номер телефону')
        .test(
          'is-valid-phone',
          field.errorMessage || 'Некоректний номер телефону',
          (value, context) => {
            const phoneFormat =
              context?.options?.context?.phoneFormatRef?.current;
            if (!phoneFormat || !value) return false;
            const cleanedValue = value.replace(/\D/g, '');
            const expectedDigits = (phoneFormat.match(/\./g) || []).length;
            return cleanedValue.length === expectedDigits;
          }
        );
    }

    if (field.name === 'budget' && field.radioOptions) {
      validator = yup.string().required(field.errorMessage || 'Оберіть бюджет');
    }

    shape[field.name] = validator;
  });

  shape.contactMethod = yup.string().required('Оберіть спосіб зв’язку');

  return yup.object().shape(shape);
};
